export default (Vue) => {
    let MessageBoxCustomConstructor = Vue.extend(require('./message.box.vue'));

    let instance;

    // let defaultCallback = (action) => {
    //     instance.resolve({
    //         value: instance.vm.inputValue,
    //         action: action
    //     });
    // };
    let MessageBoxCustom = function (options) {
        options = options || {};
        if (typeof options === 'string') {
            options = {
                message: options
            };
        }
        let userOnClose = options.onClose;

        options.onClose = function () {
            MessageBoxCustom.close(id, userOnClose);
        };

        instance = new MessageBoxCustomConstructor({
            data: options
        });
        instance.vm = instance.$mount();
        document.body.appendChild(instance.vm.$el);
        instance.vm.visible = true;
        instance.dom = instance.vm.$el;
        return instance.vm;
    };
    ['alert_html', 'confirm_html', 'prompt_html', 'msgbox_html'].forEach(type => {
        let proxy = '$' + type;
        MessageBoxCustom[proxy] = (options) => {
            options.type = type;
            let promise = new Promise(function (resolve, reject) {
                options.resolve = resolve;
                options.reject = reject;
            });
            MessageBoxCustom(options);
            return promise;
        };
        Vue.prototype[proxy] = MessageBoxCustom[proxy];
    });
    return MessageBoxCustomConstructor;
};



// WEBPACK FOOTER //
// ./src/components/messagebox-custom/message.box.js